import { Genders } from "../constants/Genders";

export const convertGenderFromEnum = (genderEnum: Genders) => {
    if (genderEnum === Genders.male) {
        return 1;
    }
    if (genderEnum === Genders.female) {
        return 2;
    }
    return 3;
}

export const convertGenderToEnum = (genderNum: number) => {
    if (genderNum === 1) {
        return Genders.male;
    }
    if (genderNum === 2) {
        return Genders.female;
    }
    return Genders.other;
}